<template>
  <page>
    <div class="row">
      <div class="col-xs-8 col-sm-6 col-md-6 col-lg-4 col-xs-push-2 col-sm-push-3 col-md-push-3 col-lg-push-4">
        <div class="panel panel-default" style="background-color: rgba(255,255,255,0.4) !important;">
          <div class="panel-body text-center" style="background-color: rgba(255,255,255,0.4) !important;">
            <h3 style="font-size:24px !important">Skráðu þig inn í INNU með:</h3>
            <div class="banner">
              <div class="bannerText">
                Vinsamlegast notið rafræn skilríki.
              </div>
            </div>
            <hr />
            <!--style="margin-top: 203px !important"-->
            <div class="alert alert-danger text-left" v-if="errorList.length > 0">
              <ul class="list-unstyled">
                <li v-for="(e, idx) in errorList" :key="idx">
                  {{ e }}
                </li>
              </ul>
            </div>

            <div class="alert alert-info text-left" v-if="newPassword">
              Nýtt lykilorð hefur verið stillt. Vinsamlegast skráðu þig inn með nýju lykilorði.
            </div>

            <div class="alert alert-warning text-left" v-if="changePassword">
              Lykilorðið þitt er útrunnið. Vinsamlegast skráðu þig aftur inn með núverandi lykilorði til þess að breyta lykilorði.
            </div>
            <button type="button"
              style="border-color:#e7e7e7; border-radius:5px; width:18em;margin-bottom:10px;display:inline-block;height:3.2em"
              class="btn btn-opacity-island">
              <a style="vertical-align:middle" v-bind:href="island"
                ><img title="Ísland.is" style="vertical-align: middle; size: 10px; width: 150px" src="../assets/island_is_RGB_Hvitt@2x.png" alt="Ísland.is" />
              </a>
            </button>
            <button
              v-if="googleEnabled"
              type="button"
              style="border-color:#e7e7e7; border-radius:5px; width:18em;margin-bottom:10px;display:inline-block;height:3.2em"
              class="btn default btn-opacity-google"
            >
              <a v-bind:href="google">
                <img src="../assets/btn_google_light_normal_ios.svg" rel="stylesheet" style="float:left;" />
                <span class="googleClass">Google</span></a
              >
            </button>
            <button
              v-if="o365Enabled"
              type="button"
              class="btn btn-opacity-office"
              style="border-radius:5px;width:18em;margin-bottom:10px;display:inline-block;height:3.2em"
            >
              <a v-bind:href="o365">
                <img style="vertical-align: middle;" src="../assets/office.svg" rel="stylesheet"  alt="Office" />
                <span class="googleClass"></span>
              </a>
            </button>

            <button
              class="btn btn-opacity btn-pw"
              v-on:click.prevent="pw()"
              style="border-radius:5px;width:18em;margin-bottom:10px;display:inline-block;height:3.2em;color:white; background-color:#666263"
              v-if="!showPassword"
            >
              Lykilorð
            </button>
            <form style="padding-top:10px; width:18em;display:inline-block" novalidate @submit.prevent="validateBeforeSubmit" v-if="showPassword">
              <div class="form-group" v-bind:class="{ 'has-error': errors.has('username') }">
                <label class="sr-only" for="username">Kennitala</label>
                <input type="text" class="form-control" id="username" name="username" placeholder="Kennitala" v-model="username" v-validate="'required'" />
                <span class="help-block" v-if="errors.has('username:required')">Vinsamlegast sláðu inn kennitölu.</span>
              </div>
              <div class="form-group" v-bind:class="{ 'has-error': errors.has('password') }">
                <label class="sr-only" for="password">Lykilorð</label>
                <input type="password" class="form-control" id="password" name="password" placeholder="Lykilorð" v-model="password" v-validate="'required'" />
                <span class="help-block" v-if="errors.has('password:required')">Vinsamlegast sláðu inn lykilorð.</span>
              </div>
              <button type="submit" class="btn btn-login" style="width: 100%; height: 40px;">INNSKRÁ</button>

              <br />
              <br />

              <div class="text-center"><a href="/gleymt-lykilord">Gleymt lykilorð?</a></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
/* global alert: false */

import config from '../services/config'
import auth from '../services/auth'
import { encodeQueryData } from '../utils'
import router from '../router'

export default {
  name: 'login',
  data() {
    return {
      // Hidden until the backend says the method is on (INS-35, INS-37)
      o365Enabled: false,
      googleEnabled: false,
      island: '/auth/island',
      iskey: '/auth/island?legacy=true',
      google: '/auth/google',
      o365: '/auth/o365',
      errorList: [],
      username: '',
      password: '',
      newPassword: false,
      changePassword: false,
      formSubmitted: false,
      showPassword: false
    }
  },
  methods: {
    pw() {
      this.showPassword = !this.showPassword
    },
    loadLoginOptions() {
      this.$http.get(config.LOGIN_OPTIONS).then(
        response => {
          this.o365Enabled = response.data.o365 === true
          this.googleEnabled = response.data.google === true
        },
        () => {
          this.o365Enabled = false
          this.googleEnabled = false
        }
      )
    },
    validateBeforeSubmit() {
      this.errorList = []

      // Validate All returns a promise and provides the validation result.
      this.$validator.validateAll().then(success => {
        if (!success) {
          // handle error
          return
        }

        var credentials = {
          username: this.username,
          password: this.password
        }

        this.$http.post(config.LOGIN_URL, credentials).then(
          response => {
            auth.login(response.data.token)
            var query = {}

            if (this.callbackUrl) {
              query.c = this.callbackUrl
            }
            if (this.callbackSystem) {
              query.s = this.callbackSystem
            }
            if (this.callbackSystem1Url) {
              query.c1 = this.callbackSystem1Url
            }

            router.push({ path: 'adgangur', query: query })
          },
          err => {
            if (err.status === 401 && err.data.message) {
              this.errorList = [err.data.message]
            } else if (err.status === 401 && err.data.detail) {
              this.errorList = [err.data.detail]
            } else {
              alert('Óvænt villa kom upp. Vinsamlegast reyndu aftur.')
            }
          }
        )
      })
    }
  },
  created() {
    this.loadLoginOptions()

    var err = 'error' in this.$route.query ? this.$route.query.error : null
    var newPassword = 'nytt_lykilord' in this.$route.query ? this.$route.query.nytt_lykilord : null
    var changePassword = 'changepassword' in this.$route.query ? this.$route.query.changepassword : null

    this.newPassword = newPassword === 'true'
    this.changePassword = changePassword === 'true'
    this.callbackUrl = 'c' in this.$route.query ? this.$route.query.c : null
    this.callbackSystem = 's' in this.$route.query ? this.$route.query.s : null
    this.callbackSystem1Url = 'c1' in this.$route.query ? this.$route.query.c1 : null

    if (this.callbackSystem1Url) {
      this.google = '/auth/google?' + encodeQueryData({ c1: this.callbackSystem1Url })
      this.o365 = '/auth/o365?' + encodeQueryData({ c1: this.callbackSystem1Url })
      this.island = '/auth/island?' + encodeQueryData({ c1: this.callbackSystem1Url })
    }

    if (err) {
      if (err === 'google_cancelled') {
        this.errorList = ['Notandi hætti við innskráningu í gegnum Google.']
      } else if (err === 'o365_cancelled') {
        this.errorList = ['Notandi hætti við innskráningu í gegnum Office 365.']
      } else if (err === 'google_notconnected') {
        this.errorList = ['Innskráður Google aðgangur er ekki tengdur við aðgang að Innu.']
      } else if (err === 'o365_notconnected') {
        this.errorList = ['Innskráður Office 365 aðgangur er ekki tengdur við aðgang að Innu.']
      } else if (err === 'island_not_connected') {
        this.errorList = ['Kennitala notanda frá Ísland.is er ekki tengd við aðgang að Innu.']
      } else if (err === 'google_error') {
        this.errorList = ['Óvænt villa kom frá innskráningarþjónustu Google. Vinsamlegast reyndu aftur.']
      } else if (err === 'o365_error') {
        this.errorList = ['Óvænt villa kom frá innskráningarþjónustu Office 365. Vinsamlegast reyndu aftur.']
      } else if (err === 'island_error') {
        this.errorList = ['Óvænt villa kom frá innskráningarþjónustu Ísland.is. Vinsamlegast reyndu aftur.']
      } else if (err === 'login_error') {
        this.errorList = this.$root.loginError == null ? [] : this.$root.loginError
        this.$root.loginError = null
      } else if (err === 'azure_cancelled') {
        this.errorList = ['Notandi hætti við innskráningu í gegnum vefpóst skóla.']
      } else if (err === 'azure_notconnected') {
        this.errorList = ['Innskráður aðgangur að vefpósti skóla er ekki tengdur við aðgang að Innu. Vinsamlegast hafðu samband við skóla.']
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.googleClass {
  color: #000000;
  font-family: 'Roboto', sans-serif;
  padding-left: 24px;
  font-size: 20px;
  padding-right: 24px;
  vertical-align: middle;
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
.btn-pw {
  color: #ffffff;
  font-weight: bold;
  text-transform: uppercase;
}
.banner {
  /*float: right;*/
  padding: 15px;
  background-color: rgb(250, 192, 18);
  margin-right: 10%;
  margin-left: 10%;
  width: 80%;
}
.bannerText {
  text-align: center;
  margin: 1%;
  margin-top: 5px;
}
</style>
